export default "__VITE_ASSET__GIFE5XhC__"